import { Pipe, PipeTransform } from '@angular/core';
import { StickerMovementType } from '~core/models/sticker.models';

@Pipe({
  name: 'stickerMovementType',
  pure: true,
  standalone: true
})
export class StickerMovementTypePipe implements PipeTransform {
  private readonly _typeMap: Record<StickerMovementType, string> = {
    [StickerMovementType.credit]: 'Rechargement',
    [StickerMovementType.debit]: 'Consommation',
    [StickerMovementType.balanceCarryover]: 'Report de solde'
  };

  transform(type: StickerMovementType): string {
    return this._typeMap[type] || type;
  }
}
